import "./token.mjs";
import "ethers";
import "@deorderbook/contracts/abi";
import "../store/provider.mjs";
import "@deorderbook/contracts";
import { useDOBContract as r } from "../store/dobContract.mjs";
import "../store/subgraph.mjs";
function m(n) {
  return r().balanceOf(n);
}
function f(n, t) {
  return r().allowance(n, t);
}
function l(n, t) {
  return r(!0).approve(n, t);
}
function d() {
  return "1000000000000000000000000000";
}
function A() {
  return "1000000000000000000000000000";
}
function O() {
  return r().pendingAdmin();
}
export {
  A as MAX_SUPPLY,
  f as allowance,
  l as approve,
  m as balanceOf,
  O as pendingAdmin,
  d as totalSupply
};
//# sourceMappingURL=dob.mjs.map
